/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import { compose } from 'recompose';
import Typography from '@material-ui/core/Typography';
import ReactMarkdown from 'react-markdown';
import { withStyles } from '@material-ui/core/styles';
import {
    object, shape, string,  arrayOf, number, bool,
} from 'prop-types';
import SubscriptionPDP from '../../../SubscriptionInformation/SubscriptionPDP';

const styles = (theme) => ({

    marginBottom15: {
        marginBottom: '15px',
    },
    subContainer: {
        display: 'flex',
        '& > div': {
            margin: 'auto',
        },
        [theme.breakpoints.down('xs')]: {
            '& > div': {
                width: '100%',
            },
        },
    },
    [theme.breakpoints.down('xs')]: {
        subContainerSm: {
            marginTop: 15,
        },
    },
    icon: {
        color: theme?.palette?.cms?.icon,
        margin: 'auto',
    },
    borderRight1: {
        [theme.breakpoints.up('sm')]: {
            borderRight: `1px solid ${(theme.palette.grey8)}`,
        },
    },
    subscriptionContent: {
        '& p': {
            fontSize: 16,
            margin: 4,
            [theme.breakpoints.down('xs')]: {
                margin: 2,
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: 15,
            },
        },
    },

    headingMobile: {
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
            borderBottom: `1px solid ${(theme.palette.grey8)}`,
            marginBottom: '10px',
        },
    },

    fontSize34: {
        fontSize: '34px',
    },
    marginNone: {
        '& p': {
            margin: 0,
        },
    },
    inline: {
        display: 'inline-block',
    },
    maxWidth: {
        maxWidth: '100%',
    },
});

const DiscoverySubscription = ({
    classes, subscriptionCopy, subscriptionDetailsFrequencyValue,
    subscriptionDetailsDurationValue, subscriptionConfig, subscriptionCheckbox, brand,
}) => (
    <>
        <Grid item xs={12} sm={4} lg={3} md={3} xl={3} className={`${classes.subContainer} ${classes.borderRight1} ${classes.headingMobile}`}>
            <div className={classes.subscriptionContent}>
                <Typography variant="body1">
                    {subscriptionCopy?.single_line_label ? <ReactMarkdown className={classes.marginNone} source={subscriptionCopy?.single_line_label} /> : (<strong>Subscription</strong>)}
                </Typography>
            </div>
        </Grid>
        <Grid item xs={12} sm={8} lg={9} md={9} xl={9} className={classes.subContainer}>
            <div className={classes.subscriptionContent}>
                <Typography variant="body1">
                    {subscriptionCopy?.frequency_label ? <ReactMarkdown className={`${classes.marginNone} ${classes.inline}`} source={subscriptionCopy?.frequency_label} /> : (<strong>Frequency:</strong>)} {subscriptionConfig?.subscription_interval?.[subscriptionDetailsFrequencyValue] || subscriptionDetailsFrequencyValue}
                </Typography>
            </div>
            <div className={classes.subscriptionContent}>
                <Typography variant="body1">
                    {subscriptionCopy?.duration_label ? <ReactMarkdown className={`${classes.marginNone} ${classes.inline}`} source={subscriptionCopy?.duration_label} /> : (<strong>Duration:</strong>)} {subscriptionConfig?.subscription_duration?.[subscriptionDetailsDurationValue] || subscriptionDetailsDurationValue}
                </Typography>
            </div>
        </Grid>
        {subscriptionCheckbox && (
            <SubscriptionPDP
                copy={subscriptionCopy?.offer_copy || ''}
                brand={brand}
            />
        )}
    </>
);

DiscoverySubscription.propTypes = {
    classes: object.isRequired,
    subscriptionCopy: shape({
        single_line_label: string,
        frequency_label: string,
        duration_label: string,
    }),
    subscriptionDetailsFrequencyValue: number.isRequired,
    subscriptionDetailsDurationValue: number.isRequired,
    subscriptionConfig: shape({
        subscription_duration: arrayOf(number),
        subscription_interval: arrayOf(number),
    }).isRequired,
    subscriptionCheckbox: bool,
    brand: shape({
        domain: string,
    }),
};

DiscoverySubscription.defaultProps = {
    subscriptionCopy: {},
    brand: {},
    subscriptionCheckbox: false,
};

const enhance = compose(
    withStyles(styles),
);

export default enhance(DiscoverySubscription);
